import { createSlice } from "@reduxjs/toolkit";
import { fetchTotalStats, fetchRecentTranscripts, fetchOnlineAgents, forceAwayAgent, fetchCampaigns, fetchConversationRating, isConversationPending } from "./dashboardAPI";
import { convertToMinutes, getError } from "../../app/common/libs/helper";
// import moment from "moment";
import { momentCustomInstance as moment } from '../../app/common/libs/helper'
import { toast } from 'react-toastify';

export const initialState = {
    totalStats: {
        loading: false,
        error: null,
        data: {}
    },
    transcripts: {
        loading: false,
        error: null,
        data: []
    },
    agents: {
        loading: false,
        error: null,
        data: []
    },
    deleteModalOpen: false,
    isAnyConversationPending: false,
    forceLogoutUserId: "",
    startDate: moment().subtract(29, 'days').startOf('day').format(),
    endDate: moment().endOf('day').format(),
    //selectedCampaign:{},
    selectedCampaign: { },
    campaigns: []
};

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialState,
    reducers: {
        setDate: (state, action) => {
            state.startDate = action.payload.start;
            state.endDate = action.payload.end;
        },
        setCampaign: (state, action) => {
            state.selectedCampaign = action.payload;
        },
        setCampaigns: (state, action) => {
            const campaigns = action.payload;
            const campaign_options = campaigns?.map(x => ({ value: x.id, label: x.name, primary: x.isPrimary }));
            state.selectedCampaign = campaign_options?.find(x => x.primary == true);
            state.campaigns = campaign_options;
        },
        incrementTotalChat: (state, action) => {
            state.totalStats.data.totalChats += 1;

            const startDate = new Date(state.startDate);
            const endDate = new Date(state.endDate);

            // To calculate the time difference of two dates
            var Difference_In_Time = endDate.getTime() - startDate.getTime();

            // To calculate the no. of days between two dates
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            if (Difference_In_Days <= 0.5) {
                var averageChats = state.totalStats.data.totalChats / 1;
                state.totalStats.data.avgChatPerDay = Math.round(averageChats);
            }
            var averageChats = state.totalStats.data.totalChats / Math.round(Difference_In_Days);

            state.totalStats.data.avgChatPerDay = Math.round(averageChats);
        },
        addOnlineOfflineAgentIntoGrid: (state, action) => {
            if (!action.payload.isOnline) {
                state.agents.data = state.agents.data.filter(x => x.email != action.payload.data.Email);
                return;
            }

            var agent = state.agents.data.find(x => x.email == action.payload.data.Email);
            if (!agent) {
                state.agents.data.push({
                    name: action.payload.data.Name,
                    email: action.payload.data.Email,
                    isOnline: action.payload.isOnline,
                    id: action.payload.data.UserId,
                    agentStatus: action.payload.agentStatus
                });
            }
        },
        setRatingLoading: (state, action) => {
            let conversation = state.transcripts.data.find(a => a.conversationSid == action.payload);
            if (conversation) {
                conversation.loading = true;
            }
        },
        addTranscriptIntoGrid: (state, action) => {
            var data = state.transcripts.data.find(x => x.id == action.payload.Id);
            if (data) {
                return;
            }
            if (state.transcripts.data.length == 10) {
                state.transcripts.data.pop();
            }

            // var isConversationExist = state.transcripts.data.find(x=> x.visitorId == action.payload.VisitorId);
            // if(isConversationExist) {
            //     state.transcripts.data = state.transcripts.data.filter(x=> x.visitorId != action.payload.VisitorId)
            // }

            state.transcripts.data.unshift({
                id: action.payload.Id,
                conversationSid: action.payload.CustomerConversationSid,
                nickName: action.payload.NickName,
                hasRated: false,
                dateCreated: action.payload.DateCreated,
                visitorId: action.payload.VisitorId,
                messageCount: 1,
                customerInfo: {
                    site_url: action.payload.CustomerInfo.SiteUrl,
                    name: action.payload.CustomerInfo.Name,
                    email: action.payload.CustomerInfo.Email,
                    address: {
                        country: action.payload.CustomerInfo.Address?.Country,
                        city: action.payload.CustomerInfo.Address?.City,
                        state: action.payload.CustomerInfo.Address?.State,
                        zip: action.payload.CustomerInfo.Address?.Zip,
                        ip: action.payload.CustomerInfo.Address?.IP
                    }
                },
                channelType: action.payload.ChannelType,
                ratingLoaded: false,
                returningVisitor: action.payload.ReturningVisitor,
                rating: {
                    feedback: '',
                    avgRatingValue: 0,
                    questions: [{ category: 0, rating: 0 }, { category: 1, rating: 0 }]
                },
                agentInfo: {}
            });
        },
        UpdateAgentInfoToTranscript: (state, action) => {
            var data = state.transcripts.data.find(x => x.id == action.payload.Id);
            if (data) {
                data.agentInfo = {
                    name: action.payload.AgentInfo.AgentName,
                    email: action.payload.AgentInfo.Email
                }
            }
        },
        UpdateRatingOnTranscript: (state, action) => {
            var data = state.transcripts.data.find(x => x.id == action.payload.ConversationId);
            if (data) {
                const questions = [];
                action.payload.Questions.forEach((item) => {
                    const rate = { category: item.Category, rating: item.Rating, question: item.Question };
                    questions.push(rate);
                })
                const avgRatingValue = action.payload.AvgRatingValue;
                const feedback = action.payload.Feedback;
                data.ratingLoaded = true;
                data.rating = {
                    questions, avgRatingValue, feedback
                };
            }
        },
        incrementOfflineMessages: (state, action) => {
            state.totalStats.data.totalOfflineMessages += 1;
        },
        setOnlineStatus: (state, action) => {
            const index = state.agents.data.findIndex(x => x.email == action.payload.email);
            if (index > -1) {
                state.agents.data[index].agentStatus = action.payload.agentStatus;
                state.agents.data[index].isOnline = action.payload.value;
            }
        },
        setDashboardHasRated: (state, action) => {
            let conversation = state.transcripts.data.find(a => a.conversationSid == action.payload);
            if (conversation) {
                conversation.hasRated = true;
            }
        },
        UpdateTranscriptMessageCount: (state, action) => {
            var data = state.transcripts.data.find(x => x.id == action.payload.ConversationId);
            if (data) {
                data.messageCount += 1;
            }
        },
        removeAgent: (state, action) => {
            state.agents.data.splice(action.payload, 1);
        },
        setDeleteModalState: (state, action) => {
            state.deleteModalOpen = action.payload;
        },
        setForceLogoutUserId: (state, action) => {
            state.forceLogoutUserId = action.payload;
        }
    },
    extraReducers: {
        [fetchTotalStats.pending]: (state) => {
            state.totalStats.loading = true;
        },
        [fetchTotalStats.rejected]: (state, { meta, error }) => {
            state.totalStats.loading = false;
            state.totalStats.data = {};
            state.totalStats.error = error;
        },
        [fetchTotalStats.fulfilled]: (state, { meta, payload: { data } }) => {
            state.totalStats.loading = false;
            state.totalStats.error = '';
            data.avgResponseTime = convertToMinutes(data.avgResponseTime);
            state.totalStats.data = data;
        },
        [fetchRecentTranscripts.pending]: (state) => {
            state.transcripts.loading = true;
        },
        [fetchRecentTranscripts.rejected]: (state, { meta, error }) => {
            state.transcripts.loading = false;
            state.transcripts.data = [];
            state.transcripts.error = error;
        },
        [fetchRecentTranscripts.fulfilled]: (state, { meta, payload: { data } }) => {
            state.transcripts.loading = false;
            state.transcripts.error = '';
            state.transcripts.data = data;

            state.transcripts.data.forEach((element) => {
                element.obtainedRating = element.rating;
                element.ratingLoaded = false;
                element.rating = {
                    feedback: '',
                    avgRatingValue: 0,
                    questions: [{ category: 0, rating: 0 }, { category: 1, rating: 0 }]
                };
            });
        },
        [fetchConversationRating.pending]: (state) => {
            // set conversation rating
            // state.messages.conversationRating.ratingLoaded = false;
            // state.messages.conversationRating.rating = {
            //     feedback: '',
            //     avgRatingValue: 0,
            //     questions: [
            //         { category: 0, rating: 0 },
            //         { category: 1, rating: 0 },
            //     ],
            // };
        },
        [fetchConversationRating.rejected]: (state, { meta, error }) => {
            let conversation = state.transcripts.data.find(a => a.conversationSid == meta.arg);
            if (conversation) {
                conversation.ratingLoaded = false;
            }
            toast.error(`${meta.arg} ' : Unable to get rating...!`);
        },
        [fetchConversationRating.fulfilled]: (state, { meta, payload: { data } }) => {
            console.log('fetchConversationRating : ' + meta.arg);

            let { conversationSid: sessionId, questions, avgRatingValue, feedback } = data;
            let conversation = state.transcripts.data.find(a => a.conversationSid == meta.arg);

            // set conversation rating
            // state.messages.conversationRating.ratingLoaded = true;
            // state.messages.conversationRating.rating = {
            //     questions, avgRatingValue, feedback
            // };

            if (conversation) {
                console.log('fetchConversationRating updating : ' + conversation.id);
                conversation.ratingLoaded = true;
                conversation.rating = {
                    questions, avgRatingValue, feedback
                };
            }
        },
        [fetchOnlineAgents.pending]: (state) => {
            state.agents.loading = true;
        },
        [fetchOnlineAgents.rejected]: (state, { meta, error }) => {
            state.agents.loading = false;
            state.agents.data = [];
            state.agents.error = error;
        },
        [fetchOnlineAgents.fulfilled]: (state, { meta, payload: { data } }) => {
            state.agents.loading = false;
            state.agents.error = '';
            state.agents.data = data.filter(x => x.isOnline == true);
        },
        [forceAwayAgent.pending]: (state) => {
        },
        [forceAwayAgent.rejected]: (state, action) => {
            if(action.payload.errors) {
                toast.error(`${getError(action.payload)}`);
            }
            else {
                toast.error(`Unable to force away at the moment ...!`);
            }        
        },
        [forceAwayAgent.fulfilled]: (state, { meta, payload: { data } }) => {
            let agent = state.agents.data.find(x => x.id === meta.arg);
            if (agent) {
                agent.isOnline = false;
                toast.success(`${agent.email} ' is force away...!`);
            }
        },
        [fetchCampaigns.fulfilled]: (state, { meta, payload: { data } }) => {
            state.campaigns = data;
            //state.selectedCampaign = data?.length > 0 ? data[0] : {};
        },
        [fetchCampaigns.rejected]: (state, { meta, error }) => {
            toast.error(`Campaigns not loaded`);
            state.campaigns = [];
        },
        [isConversationPending.pending]: (state) => {
            state.agents.loading = true;
        },
        [isConversationPending.rejected]: (state, { meta, error }) => {
            state.agents.loading = false;
        },
        [isConversationPending.fulfilled]: (state, { meta, payload: { data } }) => {
            state.agents.loading = false;
            state.isAnyConversationPending = data;
            state.deleteModalOpen = true;
        }
    },
});
export const { setDate, setCampaign, incrementTotalChat, addTranscriptIntoGrid, UpdateAgentInfoToTranscript, addOnlineOfflineAgentIntoGrid, incrementOfflineMessages, setOnlineStatus, setRatingLoading, UpdateRatingOnTranscript, setDashboardHasRated, UpdateTranscriptMessageCount, removeAgent, setCampaigns, setDeleteModalState, setForceLogoutUserId } = dashboardSlice.actions;
export default dashboardSlice.reducer;